// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Extra from "../Data.Enum.Extra/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var PL = (function () {
    function PL() {

    };
    PL.value = new PL();
    return PL;
})();
var EN = (function () {
    function EN() {

    };
    EN.value = new EN();
    return EN;
})();
var EN_GB = (function () {
    function EN_GB() {

    };
    EN_GB.value = new EN_GB();
    return EN_GB;
})();
var RO = (function () {
    function RO() {

    };
    RO.value = new RO();
    return RO;
})();
var RU = (function () {
    function RU() {

    };
    RU.value = new RU();
    return RU;
})();
var CS = (function () {
    function CS() {

    };
    CS.value = new CS();
    return CS;
})();
var SK = (function () {
    function SK() {

    };
    SK.value = new SK();
    return SK;
})();
var HR = (function () {
    function HR() {

    };
    HR.value = new HR();
    return HR;
})();
var DE = (function () {
    function DE() {

    };
    DE.value = new DE();
    return DE;
})();
var NL = (function () {
    function NL() {

    };
    NL.value = new NL();
    return NL;
})();
var ES = (function () {
    function ES() {

    };
    ES.value = new ES();
    return ES;
})();
var PT_BR = (function () {
    function PT_BR() {

    };
    PT_BR.value = new PT_BR();
    return PT_BR;
})();
var toText = function (v) {
    if (v instanceof PL) {
        return "pl";
    };
    if (v instanceof EN) {
        return "en";
    };
    if (v instanceof EN_GB) {
        return "en-GB";
    };
    if (v instanceof RO) {
        return "ro";
    };
    if (v instanceof RU) {
        return "ru";
    };
    if (v instanceof CS) {
        return "cs";
    };
    if (v instanceof SK) {
        return "sk";
    };
    if (v instanceof HR) {
        return "hr";
    };
    if (v instanceof DE) {
        return "de";
    };
    if (v instanceof NL) {
        return "nl";
    };
    if (v instanceof ES) {
        return "es";
    };
    if (v instanceof PT_BR) {
        return "pt-BR";
    };
    throw new Error("Failed pattern match at Restaumatic.Locales (line 72, column 3 - line 84, column 21): " + [ v.constructor.name ]);
};
var genericLocale = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return PL.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return EN.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return EN_GB.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return RO.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return RU.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return CS.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return SK.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return HR.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return DE.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return NL.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return ES.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))) {
            return PT_BR.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Locales (line 31, column 1 - line 31, column 50): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PL) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof EN) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof EN_GB) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof RO) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof RU) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof CS) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof SK) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof HR) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof DE) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
        };
        if (x instanceof NL) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
        };
        if (x instanceof ES) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof PT_BR) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Locales (line 31, column 1 - line 31, column 50): " + [ x.constructor.name ]);
    }
};
var showLocale = {
    show: Data_Show_Generic.genericShow(genericLocale)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PL";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "EN";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "EN_GB";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RO";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RU";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "CS";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "SK";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "HR";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "DE";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "NL";
        }
    }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ES";
        }
    }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PT_BR";
        }
    })))))))))))))
};
var fromText = function (v) {
    if (v === "pl") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(PL.value);
    };
    if (v === "en") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(EN.value);
    };
    if (v === "en-GB") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(EN_GB.value);
    };
    if (v === "ro") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(RO.value);
    };
    if (v === "ru") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(RU.value);
    };
    if (v === "cs") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(CS.value);
    };
    if (v === "sk") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(SK.value);
    };
    if (v === "hr") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(HR.value);
    };
    if (v === "de") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(DE.value);
    };
    if (v === "nl") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(NL.value);
    };
    if (v === "es") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(ES.value);
    };
    if (v === "pt-BR") {
        return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(PT_BR.value);
    };
    return Data_Maybe.Nothing.value;
};
var unsafeDecodeLocaleFromString = function (str) {
    var v = fromText(str);
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    if (v instanceof Data_Maybe.Nothing) {
        return Unscramble.decodingError("Unrecognized locale: " + Data_Show.show(Data_Show.showString)(str));
    };
    throw new Error("Failed pattern match at Restaumatic.Locales (line 63, column 3 - line 65, column 73): " + [ v.constructor.name ]);
};
var udecodeLocale = {
    unsafeDecode: function ($97) {
        return unsafeDecodeLocaleFromString(Unscramble.decodeString($97));
    }
};
var ufromJSONKeyLocale = {
    fromJSONKey: new Unscramble.FromJSONKeyString(unsafeDecodeLocaleFromString)
};
var eqLocale = {
    eq: function (x) {
        return function (y) {
            if (x instanceof PL && y instanceof PL) {
                return true;
            };
            if (x instanceof EN && y instanceof EN) {
                return true;
            };
            if (x instanceof EN_GB && y instanceof EN_GB) {
                return true;
            };
            if (x instanceof RO && y instanceof RO) {
                return true;
            };
            if (x instanceof RU && y instanceof RU) {
                return true;
            };
            if (x instanceof CS && y instanceof CS) {
                return true;
            };
            if (x instanceof SK && y instanceof SK) {
                return true;
            };
            if (x instanceof HR && y instanceof HR) {
                return true;
            };
            if (x instanceof DE && y instanceof DE) {
                return true;
            };
            if (x instanceof NL && y instanceof NL) {
                return true;
            };
            if (x instanceof ES && y instanceof ES) {
                return true;
            };
            if (x instanceof PT_BR && y instanceof PT_BR) {
                return true;
            };
            return false;
        };
    }
};
var ordLocale = {
    compare: Data_Ord_Generic.genericCompare(genericLocale)(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))))))))))))),
    Eq0: function () {
        return eqLocale;
    }
};
var enumLocale = {
    succ: Data_Enum_Generic.genericSucc(genericLocale)(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    pred: Data_Enum_Generic.genericPred(genericLocale)(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumSum(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    Ord0: function () {
        return ordLocale;
    }
};
var encodeLocale = {
    encode: (function () {
        var $98 = Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
        return function ($99) {
            return $98(toText($99));
        };
    })()
};
var decodeLocale = {
    decode: function (f) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)(f))(function (v) {
            var v1 = fromText(v);
            if (v1 instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v1.value0);
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return Foreign.fail(Data_Identity.monadIdentity)(Foreign.ForeignError.create("Unrecognized locale: " + Data_Show.show(Data_Show.showString)(v)));
            };
            throw new Error("Failed pattern match at Restaumatic.Locales (line 51, column 5 - line 53, column 79): " + [ v1.constructor.name ]);
        });
    }
};
var boundedLocale = {
    top: Data_Bounded_Generic.genericTop(genericLocale)(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopSum(Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))))))))))))),
    bottom: Data_Bounded_Generic.genericBottom(genericLocale)(Data_Bounded_Generic.genericBottomSum(Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordLocale;
    }
};
var boundedEnumLocale = {
    cardinality: Data_Enum_Generic.genericCardinality(genericLocale)(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))))))))))))),
    toEnum: Data_Enum_Generic.genericToEnum(genericLocale)(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))))))))))))),
    fromEnum: Data_Enum_Generic.genericFromEnum(genericLocale)(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumSum(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))))))))))))),
    Bounded0: function () {
        return boundedLocale;
    },
    Enum1: function () {
        return enumLocale;
    }
};
var allLocales = Data_Enum_Extra.allEnumValues(boundedLocale)(enumLocale);
export {
    PL,
    EN,
    EN_GB,
    RO,
    RU,
    CS,
    SK,
    HR,
    DE,
    NL,
    ES,
    PT_BR,
    toText,
    fromText,
    allLocales,
    eqLocale,
    genericLocale,
    ordLocale,
    showLocale,
    enumLocale,
    boundedLocale,
    boundedEnumLocale,
    decodeLocale,
    udecodeLocale,
    ufromJSONKeyLocale,
    encodeLocale
};
//# sourceMappingURL=index.js.map
